import { useState, Suspense, lazy, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const SaleElement = ({ vaType, path, isBlockedIfMcpCreated }) => {
  const { t } = useTranslation()
  const [Sale, setSale] = useState(null)
  useEffect(() => {
    try {
      const LoadedElement = lazy(() => import(`./${vaType}/${path}/${path}.jsx`))
      setSale(LoadedElement)
    } catch (error) {
      console.error(error)
    }
  }, [path, vaType])

  if (!Sale) {
    return ''
  }

  if (isBlockedIfMcpCreated) {
    return <p> {t('additionalSales:common.script_mcp_already_created')} </p>
  }

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Sale />
    </Suspense>
  )
}

export default SaleElement
